var t = (item) => {
    return `<input class="${item.gimme('className')}-search-input" type="text" value="" />`;
}

export = t;   